<template>
  <b-container v-if="this.type" fluid style="position:relative">
    <h1>{{title || $appConfig.models[this.type].title}} <b-button v-if="$appConfig.models[this.type].allowNew" variant="secondary" size="sm" :to="'/new/' + type">+ NEW</b-button></h1>
    <b-card no-body class="filters">
      <b-tabs card v-model="tabIndex">
        <b-tab :title="$gettext('Quick Filters')" active>
          <b-card-text>
            <b-row v-if="isAccountant || isOperatorSupervisor">
              <b-col class="text-center filter-actions">
                <span v-if="reportOnValidRange" :title="$gettext('Select at least one Imputed At or Created At date range (up to 7 days)')" v-b-tooltip>
                  <b-button size="sm" variant="success" @click.prevent="updateQuickFilters" :disabled="filter.createdDateRangeActive === 0 && filter.imputedDateRangeActive === 0" v-translate>
                    Apply Filters
                  </b-button>
                </span>
                <b-badge size="md" @click="resetQuickFilters" v-translate>Reset Filters</b-badge> <b-badge size="sm" @click="saveCurrentQuickFilters" v-translate>Save this Filters' Set</b-badge>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" md="2">
                <b-form-group>
                  <label for="filter-roles" v-translate>Types</label>
                  <b-form-checkbox-group stacked id="filter-types" v-model="filter.type" :options="typesSelect"></b-form-checkbox-group>
                </b-form-group>
                <b-form-group>
                  <label for="filter-roles" v-translate>Relationship</label>
                  <b-form-checkbox-group stacked id="filter-relationship" v-model="filter.relationship" :options="relationshipsSelect"></b-form-checkbox-group>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox v-model="filter.sourceManual"><translate>Manual Accounting Notes only</translate></b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <div class="form-group">
                  <label for="filter-user-id" v-translate>Shipping IDs</label>
                  <textarea id="filter-user-id" v-model.lazy="filter.shippingId" type="text" class="mb-2 col-12 form-control" />
                </div>
                <div class="form-group">
                  <label for="filter-user-id" v-translate>Fleet Rental Order ID</label>
                  <b-input id="filter-fro-id" v-model="filter.fleetRentalOrderId" type="number" class="mb-2 col-12 form-control" />
                </div>
                <div class="form-group" v-if="$store.getters.profile.roles.findIndex(x => x.name === this.$roles.INTERNATIONAL) !== -1">
                  <label for="filter-name" v-translate>Country</label>
                  <b-form-select v-model="filter.country" :options="this.countries.map(x => { return {value: x.iso_code, text: x.name} })">
                    <template slot="first">
                      <option :value="null" v-translate>Select Country</option>
                    </template>
                  </b-form-select>
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-group">
                  <label class="" for="inline-form-input-name" v-translate>Imputed At Date Range (7 days max.)</label> <label v-show="filter.imputedDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetUpdatedDateRange" v-translate>reset range</a>]</label>
                  <date-range-picker
                    v-model="imputedDateRange"
                    @update="filter.imputedDateRangeActive++"
                    :locale-data="locale"
                    :opens="opens"
                    class="mb-2 w-100"
                    :ranges="ranges"
                    :minDate="minDate"
                    :maxDate="maxDate"
                    @start-selection="setMinDate"
                    @finish-selection="setSecondDate"
                    @toggle="discernMinDate"
                  >
                    <div slot="input" slot-scope="picker">
                      <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                      <span v-if="filter.imputedDateRangeActive === 0" style="vertical-align: middle">...</span>
                      <span v-else style="vertical-align: middle">{{moment(imputedDateRange.startDate).format('L')}} - {{moment(imputedDateRange.endDate).format('L')}}</span>
                    </div>
                  </date-range-picker>
                </div>
                <div class="form-group">
                  <label class="" for="inline-form-input-name" v-translate>Created At Date Range (7 days max.)</label> <label v-show="filter.createdDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetCreatedDateRange" v-translate>reset range</a>]</label>
                  <date-range-picker
                    v-model="createdDateRange"
                    @update="filter.createdDateRangeActive++"
                    :locale-data="locale"
                    :opens="opens"
                    class="mb-2 w-100"
                    :ranges="ranges"
                    :minDate="minDate"
                    :maxDate="maxDate"
                    @start-selection="setMinDate"
                    @finish-selection="setSecondDate"
                    @toggle="discernMinDate"
                  >
                    <div slot="input" slot-scope="picker">
                      <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                      <span v-if="filter.createdDateRangeActive === 0" style="vertical-align: middle">...</span>
                      <span v-else style="vertical-align: middle">{{moment(createdDateRange.startDate).format('L')}} - {{moment(createdDateRange.endDate).format('L')}}</span>
                    </div>
                  </date-range-picker>
                </div>
                <b-form-group v-if="isMoova">
                  <label for="filter-3p" v-translate>3P</label>
                  <b-form-radio-group  id="filter-3p" v-model="filter.isOutsourced">
                    <b-form-radio :value="false"><translate>Without 3P</translate></b-form-radio>
                    <b-form-radio :value="1"><translate>3P Only</translate></b-form-radio>
                    <b-form-radio :value="null"><translate>Both</translate></b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group><br>
                  <company-autocomplete ref="companyAc" @selected="onSearchCompanySelected" :includes="['account']" />
                  <b-badge v-for="(item, index) in filter.company" :key="index">
                    {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeCompanyFromFilters(index)">×</b-badge>
                  </b-badge>&nbsp;
                </b-form-group>
                <b-form-group>
                  <user-autocomplete ref="userAc" @selected="onSearchUserSelected" :includes="['account']" with-picture />
                  <b-badge v-for="(item, index) in filter.user" :key="index">
                    {{ item.email }} <b-badge variant="danger" href="#" @click.prevent="removeUserFromFilters(index)">×</b-badge>
                  </b-badge>&nbsp;
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Advanced Filters')" v-if="isAccountant || isOperatorSupervisor">
          <b-card-text>
            <b-row>
              <b-col lg="8" class="my-1">
                <listing-filter :filter-fields="filterFields" :pre-filters="preFilters" @refresh="refreshTable" :type="type" ref="listingFilters" />
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Saved Filters')" :disabled="savedTransactionsQuickSearches.length === 0" v-if="isAccountant || isOperatorSupervisor">
          <b-list-group>
            <b-list-group-item v-for="(savedQuickSearch, index) in savedTransactionsQuickSearches" :key="index" :href="savedQuickSearch.url" class="d-flex justify-content-between align-items-center">
              {{ savedQuickSearch.name }}
              <b-badge href="#" @click.stop.prevent="deleteSavedQuickSearch(index)" variant="danger">✕</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-row class="mb-3">
      <b-col cols="12" v-if="panel.sum !== null" class="bg-dark text-white p-3">
        <b-row>
          <b-col cols="6">
            <h4 v-translate="{data: panel.sum.toFixed(4) + ' ' + panel.currency}">Sum: %{data}</h4>
            <h5 v-translate="{data: panel.credits}">Credits: %{data}</h5>
            <h5 v-translate="{data: panel.debits}">Debits: %{data}</h5>
          </b-col>
          <b-col cols="6">
            <h4 v-translate>Shippings</h4>
            <hr class="bg-primary">
            <h5><span v-html="panel.shippings.join('<br>')"></span></h5>
          </b-col>
        </b-row>
      </b-col>

    </b-row>
    <b-row>
      <b-col class="py-1" v-translate="{totalRows: totalRows || '-'}">
        Total items: <strong>%{totalRows}</strong>
      </b-col>
      <b-col cols="12" sm="3" lg="2">
        <b-form-group horizontal :label="$gettext('Per page')" :label-cols="6" class="text-right mb-0">
          <b-form-select  cols="6" :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col order="3">
        <b-row>
          <b-col class="bg-white py-1" cols="3">
            <b-form-checkbox inline v-model="selectAllTrigger"><translate>Select/Unselect All</translate></b-form-checkbox>
          </b-col>
          <b-col class="text-center">
            <b-button size="sm" @click="accountingNoteType = 'credit'" variant="success" v-b-modal.modalAccountingNote v-translate>New CREDIT Note</b-button>
            <b-button size="sm" @click="accountingNoteType = 'debit'" variant="danger" v-b-modal.modalAccountingNote v-translate>New DEBIT Note</b-button>
            <span v-if="isSuperAdmin || isAccountant" class="d-inline-block">
              <span v-if="isSuperAdmin" class="text-right">
                <b-form-checkbox inline v-model="dbSource" value="mysql" :unchecked-value="null"><translate>Use Production DB</translate></b-form-checkbox>
                <br>
              </span>
              <span v-if="reportOnValidRange" :title="$gettext('Select at least one Imputed At date range (up to 7 days)')" v-b-tooltip>
                <b-button size="sm" @click="downloadAccountingLogCsv()" :disabled="isBusy || filter.imputedDateRangeActive === 0" v-translate>Accounting Log CSV</b-button>
              </span>
              <span v-else :title="$gettext('The reports can be generated for up to 7 days Imputed At range')" v-b-tooltip>
                <b-button size="sm" variant="warning" disabled v-translate>Accounting Log CSV</b-button>
              </span>
            </span>
          </b-col>
          <b-col class="text-right bg-white py-1" cols="3" v-if="isAccountant || isOperatorSupervisor">
            <b-button size="sm" :disabled="invalidateTransactions.length === 0" v-b-modal.modalInvalidateTransactions style="padding: .5rem" v-translate>
              Revoke Selected Transactions
            </b-button>
          </b-col>
        </b-row>
        <b-table @row-selected="rowSelected" id="transactions-table" ref="transactionsTable" stacked="md" foot-clone :total-rows="totalRows" :sort-desc="sortDesc" :sort-by="sortBy" :per-page="perPage" :current-page="currentPage" :busy.sync="isBusy" :items="myProvider" :fields="fields" :api-url="this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint" selectable>

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong v-translate>Loading...</strong>
          </div>

          <template #cell()="data">
            <div v-if="fields.find(x => x.key === data.field.key).filter" v-html="$options.filters[fields.find(x => x.key === data.field.key).filter](data.value)"></div>
            <div v-else-if="fields.find(x => x.key === data.field.key).formatter" v-html="data.value"></div>
            <div v-else-if="fields.find(x => x.key === data.field.key).options && fields.find(x => x.key === data.field.key).include && fields.find(x => x.key === data.field.key).showField">{{fields.find(x => x.key === data.field.key).include.find(x => x[fields.find(x => x.key === data.field.key).showKey || 'id'] === data.value)[fields.find(x => x.key === data.field.key).showField]}}</div>
            <div v-else>{{data.value}}</div>
          </template>

          <template v-slot:cell(id)="data">
            {{data.value | uuid }} <a href="#" @click.prevent="copyToClipboard(data.value)" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
          </template>

          <!-- <template v-slot:cell(shipping_id)="row">
            <a v-if="row.value" :href="'/edit/shippings/' + row.value" target="_blank">{{!row.detailsShowing ? $options.filters.uuid(row.value) : row.value }}</a> <a href="#" @click.prevent="copyToClipboard(row.value)" class="text-secondary" :title="$gettext('Copy to Clipboard')" v-if="row.value"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
          </template> -->

          <template v-slot:cell(amount)="row">
            {{row.item.type === 'credit' ? '-' : ''}}{{row.item.amount}} {{row.item.currency}}
          </template>

          <template v-slot:cell(reason)="row">
            <span :class="(row.value === 'delivered' ? 'text-success' : (row.value === 'incidence' ? 'text-warning' : 'text-dark')) + ' text-uppercase'">{{row.value}}</span>
          </template>

          <template v-slot:cell(relationship)="row">
            <span class="text-capitalize">{{row.value}}</span>
          </template>

          <template v-slot:cell(type)="row">
            <span :class="(row.value === 'credit' ? 'text-success' : 'text-danger') + ' text-capitalize'">{{row.value}}</span>
          </template>

          <template v-slot:cell(visibility)="row">
            {{row.value === 'all' ? $gettext('YES') : $gettext('NO')}}
          </template>

          <template v-slot:cell(reference)="row">
            <strong>{{row.value}}</strong>
          </template>

          <template v-slot:cell(account_owner)="row">
            <span v-if="row.item.account.reference.indexOf('user') !== -1">
              <user-card :user='row.item.account.owner' :profile-picture="false" :with-titles="false" :with-map="false" />
            </span>
            <div v-else class="company-card__profile-data">
              <h5><a target="_blank" :href="'/edit/companies/' + row.item.account.owner.id">#{{row.item.account.owner.id}}</a>
              {{row.item.account.owner.name}} <small>({{row.item.account.owner.business_name}})</small></h5>
              <p>{{row.item.account.owner.contact_name}} (<a :href="'mailto:' + row.item.account.owner.email">{{row.item.account.owner.email}}</a>)<br>
              {{row.item.account.owner.phone | phone(row.item.country_iso_code)}}</p>
            </div>
          </template>

          <template v-slot:cell(phone)="row">
            <div v-if="row.item.phone">
              {{row.item.phone}}<br>
              <a class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" v-if="row.item.phone" :href="'tel://' + row.item.phone" v-translate>Call</a>
              <a class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" v-if="row.item.phone" :href="$options.filters.whatsappize(row.item.phone)">WhatsApp</a>
            </div>
          </template>

          <template v-slot:cell(active)="row" class="text-center">
            <span :title="row.item.active ? 'Enabled' : 'Disabled'" style="display: inline-block; width:15px; height:15px; border-radius: 100px;" :class="row.item.active ? 'bg-success' : 'bg-danger'"></span>
          </template>

          <template v-slot:cell(company_id)="row">
            <div v-if="row.item.company_id">
              <a :href="'/edit/companies/' + row.item.company_id" target="_blank">#{{row.item.company_id}}</a> {{row.item.company.name}}
            </div>
          </template>

          <template v-slot:cell(imputation_date)="row">
            {{moment.utc(row.value).tz($tz).format('YYYY-MM-DD')}}<br>
            {{moment.utc(row.value).tz($tz).format('HH:mm:ss')}}
          </template>

          <template v-slot:cell(updated_at)="row">
            {{moment.utc(row.item.updated_at).tz($tz).format('YYYY-MM-DD')}}<br>
            {{moment.utc(row.item.updated_at).tz($tz).format('HH:mm:ss')}}
          </template>

          <template v-slot:cell(created_at)="row">
            {{moment.utc(row.item.created_at).tz($tz).format('YYYY-MM-DD')}}<br>
            {{moment.utc(row.item.created_at).tz($tz).format('HH:mm:ss')}}
          </template>

          <template v-slot:cell(actions)="row">
            <b-button pill size="sm" @click.stop="invalidateTransactions = [row.item];" v-b-modal.modalInvalidateTransactions style="padding: .5rem" v-if="isAccountant || isOperatorSupervisor" v-translate>
              Revoke
            </b-button>
          </template>

        </b-table>
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>

    <b-modal id="modalInvalidateTransactions" ref="modalInvalidateTransactions" size="lg" hide-footer @hidden="resetInvalidations">
      <div slot="modal-title" v-translate>Revoke Transactions</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <form class="" @submit.prevent="doInvalidateTransactions">
        <b-form-checkbox v-if="invalidateTransactions.length > 1" :value="true" :unchecked-value="false" v-model="sameRef"><translate>Same Reference for both Provider and Client when applies</translate></b-form-checkbox>
        <b-form-group v-if="sameRef && invalidateTransactions.length > 1">
          <b-form-row>
            <b-col>
              <label for="invalidation-reference" v-translate>Reference for both Provider/Client</label>
              <textarea rows="6" id="invalidation-reference" ref="invalidationReference" @focus="invalidationDef.referenceClient = invalidationDef.referenceProvider" @input="invalidationDef.referenceClient = invalidationDef.referenceProvider" v-model="invalidationDef.referenceProvider" type="text" class="mb-2 col-12 form-control" />
            </b-col>
            <b-col>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = 'Anulación de transacción #{transactionId} ({originalReference})'; $refs.invalidationReference.focus()">Anulación de transacción #{transactionId} ({originalReference})</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceClient = invalidationDef.referenceProvider + 'imagen no válida'; $refs.invalidationReference.focus()">imagen no válida</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceClient = invalidationDef.referenceProvider + 'dirección no visitada'; $refs.invalidationReference.focus()">dirección no visitada</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceClient = invalidationDef.referenceProvider + 'dirección visitada fuera de horario'; $refs.invalidationReference.focus()">dirección visitada fuera de horario</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceClient = invalidationDef.referenceProvider + 'bonificado'; $refs.invalidationReference.focus()">bonificado</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceClient = invalidationDef.referenceProvider + 'siniestro'; $refs.invalidationReference.focus()">siniestro</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceClient = invalidationDef.referenceProvider + '{transactionId}'; $refs.invalidationReference.focus()">{transactionId}</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceClient = invalidationDef.referenceProvider + '{originalReference}'; $refs.invalidationReference.focus()">{originalReference}</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceClient = invalidationDef.referenceProvider + '{shippingId}'; $refs.invalidationReference.focus()">{shippingId}</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceClient = invalidationDef.referenceProvider + '{destinationAddress}'; $refs.invalidationReference.focus()">{destinationAddress}</b-button>
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group v-if="(!sameRef && invalidateTransactions.length > 1) || (invalidateTransactions.length === 1 && invalidateTransactions[0].relationship === 'provider')">
          <b-form-row>
            <b-col>
              <label for="invalidation-reference-provider" v-translate>Reference for Provider</label>
              <textarea rows="6" id="invalidation-reference-provider" ref="invalidationReferenceProvider" v-model="invalidationDef.referenceProvider" type="text" class="mb-2 col-12 form-control" />
            </b-col>
            <b-col>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = 'Anulación de transacción #{transactionId} ({originalReference})'; $refs.invalidationReferenceProvider.focus()">Anulación de transacción #{transactionId} ({originalReference})</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceProvider + 'imagen no válida'; $refs.invalidationReferenceProvider.focus()">imagen no válida</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceProvider + 'dirección no visitada'; $refs.invalidationReferenceProvider.focus()">dirección no visitada</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceProvider + 'dirección visitada fuera de horario'; $refs.invalidationReferenceProvider.focus()">dirección visitada fuera de horario</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceProvider + 'bonificado'; $refs.invalidationReferenceProvider.focus()">bonificado</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceProvider + 'siniestro'; $refs.invalidationReferenceProvider.focus()">siniestro</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceProvider + '{transactionId}'; $refs.invalidationReferenceProvider.focus()">{transactionId}</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceProvider + '{originalReference}'; $refs.invalidationReferenceProvider.focus()">{originalReference}</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceProvider + '{shippingId}'; $refs.invalidationReferenceProvider.focus()">{shippingId}</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceProvider = invalidationDef.referenceProvider + '{destinationAddress}'; $refs.invalidationReferenceProvider.focus()">{destinationAddress}</b-button>
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group v-if="(!sameRef && invalidateTransactions.length > 1) || (invalidateTransactions.length === 1 && invalidateTransactions[0].relationship === 'client')">
          <b-form-row>
            <b-col>
              <label for="invalidation-reference-client" v-translate>Reference for Client</label>
              <textarea rows="6" id="invalidation-reference-client" ref="invalidationReferenceClient" v-model="invalidationDef.referenceClient" type="text" class="mb-2 col-12 form-control" />
            </b-col>
            <b-col>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceClient = 'Anulación de transacción #{transactionId} ({originalReference})'; $refs.invalidationReferenceClient.focus()">Anulación de transacción #{transactionId} ({originalReference})</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceClient = invalidationDef.referenceClient + 'imagen no válida'; $refs.invalidationReferenceClient.focus()">imagen no válida</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceClient = invalidationDef.referenceClient + 'dirección no visitada'; $refs.invalidationReferenceClient.focus()">dirección no visitada</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceClient = invalidationDef.referenceClient + 'dirección visitada fuera de horario'; $refs.invalidationReferenceClient.focus()">dirección visitada fuera de horario</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceClient = invalidationDef.referenceClient + 'bonificado'; $refs.invalidationReferenceClient.focus()">bonificado</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceClient = invalidationDef.referenceClient + 'siniestro'; $refs.invalidationReferenceClient.focus()">siniestro</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceClient = invalidationDef.referenceClient + '{transactionId}'; $refs.invalidationReferenceClient.focus()">{transactionId}</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceClient = invalidationDef.referenceClient + '{originalReference}'; $refs.invalidationReferenceClient.focus()">{originalReference}</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceClient = invalidationDef.referenceClient + '{shippingId}'; $refs.invalidationReferenceClient.focus()">{shippingId}</b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem; margin: 0.1rem" @click.prevent="invalidationDef.referenceClient = invalidationDef.referenceClient + '{destinationAddress}'; $refs.invalidationReferenceClient.focus()">{destinationAddress}</b-button>
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-row>
          <b-col cols="6">
            <b-form-group>
              <label for="invalidation-imputation-date" v-translate>Imputation Date</label>
              <b-form-radio-group stacked v-model="invalidationDef.imputation_date">
                <b-form-radio value="transaction"><translate>Same of transaction</translate></b-form-radio>
                <b-form-radio value="now"><translate>Now</translate></b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label for="invalidation-imputation-date" v-translate>Take</label>
              <b-form-radio-group stacked v-model="invalidationDef.visibility">
                <b-form-radio value="all"><translate>YES</translate></b-form-radio>
                <b-form-radio value="internal"><translate>NO</translate></b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="text-right form-group col-12 form-actions">
          <b-button type="submit" variant="primary" size="lg" v-translate>Invalidate</b-button>
          <b-button type="button" variant="outline-primary" size="lg" @click.prevent="$refs.modalInvalidateTransactions.hide()" v-translate>Cancel</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal size="md" id="modalAccountingNote" ref="modalAccountingNote" hide-footer>
      <div slot="modal-title" v-translate>New Accounting Note</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <accounting-note-form :type="accountingNoteType" @cancel="$refs.modalAccountingNote.hide()" @success="accountingNoteCreated('modalAccountingNote');" />
    </b-modal>
  </b-container>
</template>

<script>
function initialQuickFilters() {
  return {
    type: [],
    relationship: [],
    sourceManual: false,
    shippingId: '',
    fleetRentalOrderId: null,
    imputationDate: null,
    createdAt: null,
    company: [],
    user: [],
    country: null,
    createdDateRangeActive: 0,
    imputedDateRangeActive: 0,
    isOutsourced: null
  }
}
import ListingFilter from '@/components/ListingFilter'
import DraggableDiv from '@/components/DraggableDiv'
import DateRangePicker from 'vue2-daterange-picker'
import UserCard from '@/components/UserCard'
import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'
import UserAutocomplete from '@/components/autocompletes/UserAutocomplete'
import AccountingNoteForm from '@/components/AccountingNoteForm'

export default {
  name: 'TransactionsList',
  components: {
    ListingFilter,
    DraggableDiv,
    DateRangePicker,
    UserCard,
    CompanyAutocomplete,
    UserAutocomplete,
    AccountingNoteForm
  },
  props: {
    type: {
      type: String,
      default: 'transactions'
    },
    title: {
      type: String
    },
    preFilters: {
      type: Array,
      default: () => {
        return []
      }
    },
    prePerPage: {
      type: Number,
      default: 100
    }
  },
  data () {
    return {
      tabIndex: 0,
      fields: [],
      filterFields: this.$appConfig.models[this.type].filters,
      exclude: this.$appConfig.models[this.type].exclude,
      includes: this.$appConfig.models[this.type].includes || [],
      isBusy: false,
      currentPage: 1,
      perPage: this.prePerPage,
      totalRows: null,
      pageOptions: [ 10, 25, 50, 100, 500 ],
      sortBy: 'updated_at',
      sortDesc: true,
      sortDirection: 'desc',
      typesSelect: [
        {
          text: 'Credit',
          value: 'credit'
        },
        {
          text: 'Debit',
          value: 'debit'
        }
      ],
      relationshipsSelect: [
        {
          text: 'Provider',
          value: 'provider'
        },
        {
          text: 'Client',
          value: 'client'
        }
      ],
      filters: this.preFilters,
      filter: initialQuickFilters(),
      quickFilters: {},
      savedTransactionsQuickSearches: [],
      companyAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('Company Name, Business Name or TIN'),
        inputClass: 'form-control'
      },
      searchCompanyQuery: '',
      userAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('User Name or Email'),
        inputClass: 'form-control'
      },
      searchUserQuery: '',
      minCharacter: 2,
      panel: {
        sum: null,
        currency: null,
        shippings: [],
        credits: 0,
        debits: 0
      },
      selectAllTrigger: false,
      locale: {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 0,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      },
      ranges: { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()]
      },
      createdDateRange: { // used for v-model prop
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      },
      imputedDateRange: { // used for v-model prop
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      },
      opens: 'right',
      minDate: null,
      dateSelectionComplete: false,
      invalidateTransactions: [],
      invalidationDef: {
        referenceProvider: '',
        referenceClient: '',
        imputation_date: 'transaction',
        visibility: 'all'
      },
      sameRef: true,
      // accountingNote: {
      //   account_id: null,
      //   type: 'credit',
      //   amount: null,
      //   currency: '',
      //   shipping_id: null,
      //   relationship: 'client',
      //   reference: '',
      //   visibility: 'all',
      //   imputation_date: null
      // },
      // accountSearchType: 'user',
      // accountOwner: '',
      // currencySelect: [],
      dbSource: null,
      accountingNoteType: 'credit'
      // minAccountingNoteImputationDate: this.moment().subtract(1, 'month').format('YYYY-MM-DD'),
      // maxAccountingNoteImputationDate: this.moment().format('YYYY-MM-DD')
    }
  },
  watch: {
    type: function (val) {
      console.log(this.type)
      console.log(val)
      this.resetData()
      if (this.$refs.listingFilters) {
        this.$refs.listingFilters.resetData()
      }
      this.fields = this.$appConfig.models[this.type].fields
      this.filterFields = this.$appConfig.models[this.type].filters
      this.exclude = this.$appConfig.models[this.type].exclude
      // this.fields.push({ key: 'actions', label: this.$gettext('Actions') })
      let that = this
      this.fields = this.fields.filter(function (obj) {
        if (that.exclude) {
          return that.exclude.indexOf(obj.key) === -1
        } else {
          return true
        }
      })
      this.refreshTable()
    },
    exclude: function (val) {
      return this.$appConfig.models[this.type].exclude
    },
    selectAllTrigger(val) {
      if (val === true) {
        this.selectAll()
      } else {
        this.unselectAll()
      }
    },
    // accountSearchType(val) {
    //   this.accountOwner = ''
    //   this.accountingNote.account_id = null
    //   this.accountingNote.currency = ''
    // },
    'filter.type': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['type'] = [ 'type', 'in', val ]
        } else {
          this.quickFilters['type'] = []
        }
      },
      deep: true
    },
    'filter.relationship': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['relationship'] = [ 'relationship', 'in', val ]
        } else {
          this.quickFilters['relationship'] = []
        }
      },
      deep: true
    },
    'filter.sourceManual': {
      handler (val) {
        if (val) {
          this.quickFilters['sourceManual'] = [ 'accounting_note.source', 'eq', 'manual' ]
        } else {
          this.quickFilters['sourceManual'] = []
        }
      },
      deep: true
    },
    'filter.shippingId': {
      handler (val) {
        console.log(val)
        if (val) {
          val = val.indexOf('\n') !== -1 ? val.split('\n') : val.split(',')
          this.quickFilters['shippingId'] = [ 'shipping_id', 'in', val.map(x => x.replace(' ', '')) ]
        } else {
          this.quickFilters['shippingId'] = []
        }
      },
      deep: true
    },
    'filter.fleetRentalOrderId': {
      handler (val) {
        console.log(val)
        if (val) {
          this.quickFilters['fleetRentalOrderId'] = [ 'fleet_rental_order_id', 'eq', val ]
        } else {
          this.quickFilters['fleetRentalOrderId'] = []
        }
      },
      deep: true
    },
    'filter.company': {
      handler (val) {
        if (val.length > 0) {
          let companies = val.map(function (item) {
            return item.account_id || null
          })
          let companyNames = val.map(function (item) {
            return item.name
          })
          if (companies.length === 1) {
            this.quickFilters['company'] = [[ 'account_id', 'eq', companies[0] ], companyNames]
          } else {
            this.quickFilters['company'] = [[ 'account_id', 'in', companies ], companyNames]
          }
        } else {
          this.quickFilters['company'] = []
        }
      },
      deep: true
    },
    'filter.user': {
      handler (val) {
        if (val.length > 0) {
          let users = val.map(function (item) {
            return item.account_id || null
          })
          let userEmails = val.map(function (item) {
            return item.email
          })
          if (users.length === 1) {
            this.quickFilters['user'] = [[ 'account_id', 'eq', users[0] ], userEmails]
          } else {
            this.quickFilters['user'] = [[ 'account_id', 'in', users ], userEmails]
          }
        } else {
          this.quickFilters['user'] = []
        }
      },
      deep: true
    },
    'filter.country': {
      handler (val) {
        if (val) {
          this.quickFilters['country'] = [ 'country_iso_code', 'eq', val ]
        } else {
          this.quickFilters['country'] = []
        }
      },
      deep: true
    },
    'filter.createdDateRangeActive': {
      handler (val) {
        if (val !== 0) {
          console.log(this.createdDateRange.startDate)
          this.quickFilters['createdAtFrom'] = ['created_at', 'gte', this.createdDateRange.startDate.length === 19 ? this.moment(this.createdDateRange.startDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.createdDateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.quickFilters['createdAtTo'] = ['created_at', 'lte', this.createdDateRange.endDate.length === 19 ? this.moment(this.createdDateRange.endDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.createdDateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
        } else {
          this.quickFilters['createdAtFrom'] = []
          this.quickFilters['createdAtTo'] = []
        }
      },
      deep: true
    },
    'filter.imputedDateRangeActive': {
      handler (val) {
        if (val !== 0) {
          this.quickFilters['imputationDateFrom'] = ['imputation_date', 'gte', this.imputedDateRange.startDate.length === 19 ? this.moment(this.imputedDateRange.startDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.imputedDateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.quickFilters['imputationDateTo'] = ['imputation_date', 'lte', this.imputedDateRange.endDate.length === 19 ? this.moment(this.imputedDateRange.endDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.imputedDateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
        } else {
          this.quickFilters['imputationDateFrom'] = []
          this.quickFilters['imputationDateTo'] = []
        }
      },
      deep: true
    },
    'filter.isOutsourced': {
      handler (val) {
        if (val !== null) {
          this.quickFilters['isOutsourced'] = [ 'is_outsourcing', 'eq', val ]
        } else {
          this.quickFilters['isOutsourced'] = []
        }
      },
      deep: true
    }
  },
  computed: {
    // accountingNoteReady() {
    //   return this.accountingNote.account_id &&
    //     this.accountingNote.amount &&
    //     this.accountingNote.type &&
    //     this.accountingNote.currency &&
    //     this.accountingNote.relationship &&
    //     this.accountingNote.reference
    // },
    applyFilter () {
      return this.filter
    },
    reportOnValidRange() {
      return this.moment.duration(this.elapsedTimeRaw(this.moment(this.imputedDateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'), this.moment(this.imputedDateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')), 'milliseconds').asDays() < 7
    },
    maxDate() {
      return this.minDate ? this.moment(this.minDate).add(6, 'days').format('YYYY-MM-DD') : null
    }
  },
  created() {
    this.fetchCountries()
    this.fetchRoles()
    window.addEventListener('popstate', () => {
      if (this.$route.query.s) {
        this.tabIndex = 1
        this.checkAdvancedFilters()
      } else if (this.$route.query.qs) {
        this.tabIndex = 0
        this.checkQuickFilters()
      }
    })
  },
  mounted() {
    this.resetData()
    this.fields = this.$appConfig.models[this.type].fields
    this.includes = this.$appConfig.models[this.type].includes
    this.exclude = this.$appConfig.models[this.type].exclude
    let that = this
    let fields = this.fields.filter(function (obj) {
      if (that.exclude) {
        return that.exclude.indexOf(obj.key) === -1
      } else {
        return true
      }
    })
    fields.push({ key: 'actions', label: this.$gettext('Actions') })
    this.fields = fields
    if (this.$route.query.s) {
      this.tabIndex = 1
      this.checkAdvancedFilters()
    } else if (this.$route.query.qs) {
      this.checkQuickFilters()
    } else {
      this.refreshTable()
    }
    if (localStorage.savedTransactionsQuickSearches) {
      this.savedTransactionsQuickSearches = JSON.parse(localStorage.savedTransactionsQuickSearches)
    }
  },
  methods: {
    setMinDate(e) {
      this.minDate = this.moment(e).format('YYYY-MM-DD')
    },
    setSecondDate(e) {
      this.dateSelectionComplete = true
    },
    discernMinDate(show, e) {
      if (show === false && (!this.dateSelectionComplete || (this.dateSelectionComplete && !this.dateRangeActive))) {
        this.minDate = null
      }
    },
    async doInvalidateTransactions() {
      let invalidations = this.invalidateTransactions.map(x => {
        return {
          id: x.id,
          account_id: x.account_id,
          type: x.type === 'debit' ? 'credit' : 'debit',
          amount: x.amount,
          currency: x.currency,
          relationship: x.relationship,
          imputation_date: x.imputation_date,
          reference: x.reference,
          shipping_id: x.shipping_id || null,
          toAddress: x.shipping ? x.shipping.address_to.formatted_address : null
        }
      })

      invalidations.forEach(async (invalidation, i) => {
        if (invalidation.relationship === 'client') {
          invalidation['reference'] = this.invalidationDef.referenceClient.replace(/\{transactionId}/g, invalidation.id)
            .replace(/\{originalReference}/g, invalidation.reference)
            .replace(/\{shippingId}/g, invalidation.shipping_id || '')
            .replace(/\{destinationAddress}/g, invalidation.toAddress || '')
        } else {
          invalidation['reference'] = this.invalidationDef.referenceProvider.replace(/\{transactionId}/g, invalidation.id)
            .replace(/\{originalReference}/g, invalidation.reference)
            .replace(/\{shippingId}/g, invalidation.shipping_id || '')
            .replace(/\{destinationAddress}/g, invalidation.toAddress || '')
        }
        invalidation['imputation_date'] = this.invalidationDef.imputation_date === 'transaction' ? invalidation.imputation_date : this.moment().utc().format('YYYY-MM-DD HH:mm:ss')
        invalidation['visibility'] = this.invalidationDef.visibility

        await this.$http.post(this.$appConfig.api.baseUrl + 'accounting-notes', invalidation)
          .then(async response => {
            if (this.isAccountApprover) {
              await this.autoApproveNote(response.body.id)
            }
            if ((i + 1) === invalidations.length) {
              this.updateQuickFilters()
              this.$refs.modalInvalidateTransactions.hide()
            }
          })
      })
    },
    resetInvalidations() {
      this.sameRef = true
      Object.assign(this.$data.invalidationDef, this.$options.data.call(this).invalidationDef)
    },
    async autoApproveNote(id) {
      let payload = {
        status: 'approved',
        review_notes: 'Manually created by FIN'
      }
      await this.$http.patch(this.$appConfig.api.baseUrl + 'accounting-notes/' + id + '/review', payload)
    },
    // doAccountingNote() {
    //   if (
    //     confirm('Are you sure you want to create the ' + this.accountingNote.type.toUpperCase() + ' Accounting Note?')
    //   ) {
    //     this.accountingNote.shipping_id = this.accountingNote.shipping_id || null
    //     if (!this.accountingNote.shipping_id) {
    //       if (
    //         confirm(this.$gettext('The Accounting Note you are creating DOES NOT reference any Shipping ID. This will affect resulting take of the account.\n\nAre you sure you want to continue?'))
    //       ) {
    //         if (this.accountingNote.imputation_date) {
    //           this.accountingNote.imputation_date = this.moment(this.accountingNote.imputation_date + ' ' + '00:00:00').utc().format('YYYY-MM-DD HH:mm:ss')
    //         } else {
    //           delete this.accountingNote.imputation_date
    //         }

    //         this.$http.post(this.$appConfig.api.baseUrl + 'accounting-notes', this.accountingNote)
    //           .then(response => {
    //             this.updateQuickFilters()
    //             this.$refs.modalAccountingNote.hide()
    //           })
    //       }
    //     } else {
    //       if (this.accountingNote.imputation_date) {
    //         this.accountingNote.imputation_date = this.moment(this.accountingNote.imputation_date + ' ' + '00:00:00').utc().format('YYYY-MM-DD HH:mm:ss')
    //       } else {
    //         delete this.accountingNote.imputation_date
    //       }

    //       this.$http.post(this.$appConfig.api.baseUrl + 'accounting-notes', this.accountingNote)
    //         .then(response => {
    //           this.updateQuickFilters()
    //           this.$refs.modalAccountingNote.hide()
    //         })
    //     }
    //   }
    // },
    // resetAccountingNote() {
    //   this.accountOwner = ''
    //   this.searchCompanyQuery = ''
    //   this.searchUserQuery = ''
    //   Object.assign(this.$data.accountingNote, this.$options.data.call(this).accountingNote)
    // },
    checkAdvancedFilters() {
      // this.quickFilters = []
      if (this.$route.query.s) {
        this.advancedFilters = JSON.parse(this.$route.query.s)
        if (this.$refs.listingFilters) {
          this.$refs.listingFilters.filters = this.advancedFilters
        }
        console.log(this.advancedFilters)
      }
      this.refreshTable(this.advancedFilters)
    },
    checkQuickFilters() {
      this.advancedFilters = []
      if (this.$refs.listingFilters) {
        this.$refs.listingFilters.resetData()
      }
      if (this.$route.query.qs) {
        this.quickFilters = JSON.parse(this.$route.query.qs)
        Object.keys(JSON.parse(this.$route.query.qs)).forEach(function (key) {
          if (this.quickFilters[key].length > 2) {
            if (key === 'imputationDateFrom') {
              this.imputedDateRange.startDate = this.quickFilters[key][2]
            }
            if (key === 'imputationDateTo') {
              this.imputedDateRange.endDate = this.quickFilters[key][2]
              this.filter.imputedDateRangeActive = true
            }
            if (key === 'createdAtFrom') {
              this.createdDateRange.startDate = this.quickFilters[key][2]
            }
            if (key === 'createdAtTo') {
              this.createdDateRange.endDate = this.quickFilters[key][2]
              this.filter.createdDateRangeActive = true
            }
            this.filter[key] = this.quickFilters[key][2]
          } else if (this.quickFilters[key].length === 2) {
            this.filter[key] = []
            for (let i = 0; i < this.quickFilters[key][0][2].length; i++) {
              this.filter[key].push({id: this.quickFilters[key][0][2][i], name: this.quickFilters[key][1][i], email: this.quickFilters[key][1][i]})
            }
          }
        }.bind(this))
        this.updateQuickFilters()
      }
    },
    updateQuickFilters() {
      if (this.tabIndex === 0) {
        let filters = []
        Object.values(this.quickFilters).forEach(function (filter) {
          if (filter.length === 2) {
            filters.push(filter[0])
          } else {
            filters.push(filter)
          }
        })
        if (filters.length > 0) {
          this.$router.push({ query: {qs: this.localizeDates(JSON.stringify(this.quickFilters))} })
        }
        let cleanup = filters.findIndex(x => x[0] === 'company_id')
        if (cleanup !== -1) {
          filters.splice(filters.findIndex(x => x[0] === 'company_id'), 1)
        }
        this.refreshTable(filters)
      }
    },
    resetQuickFilters: function () {
      Object.assign(this.$data.filter, initialQuickFilters())
      Object.assign(this.$data.panel, this.$options.data.call(this).panel)
    },
    saveCurrentQuickFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedTransactionsQuickSearches.push({name: 'QUICK: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedTransactionsQuickSearches = JSON.stringify(this.savedTransactionsQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedTransactionsQuickSearches = JSON.parse(localStorage.savedTransactionsQuickSearches)
    },
    resetAdvancedFilters: function () {
      this.$refs.listingFilters.resetData()
      this.$refs.listingFilters.emitRefresh()
    },
    saveCurrentAdvancedFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedTransactionsQuickSearches.push({name: 'ADVANCED: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedTransactionsQuickSearches = JSON.stringify(this.savedTransactionsQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedTransactionsQuickSearches = JSON.parse(localStorage.savedTransactionsQuickSearches)
    },
    deleteSavedQuickSearch(index) {
      this.savedTransactionsQuickSearches.splice(index, 1)
      localStorage.savedTransactionsQuickSearches = JSON.stringify(this.savedTransactionsQuickSearches)
      this.savedTransactionsQuickSearches = JSON.parse(localStorage.savedTransactionsQuickSearches)
    },
    resetCreatedDateRange() {
      this.createdDateRange = {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      }
      this.filter.createdDateRangeActive = 0
      this.minDate = null
      this.dateSelectionComplete = false
    },
    resetUpdatedDateRange() {
      this.imputedDateRange = {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      }
      this.filter.imputedDateRangeActive = 0
      this.minDate = null
      this.dateSelectionComplete = false
    },
    myProvider (ctx) {
      console.log(ctx)
      let params = {
        page: ctx.currentPage - 1,
        limit: ctx.perPage,
        includes: this.includes,
        sort: [
          {
            key: ctx.sortBy || 'id',
            direction: ctx.sortDesc ? 'desc' : 'asc'
          }
        ]
      }
      console.log(this.filters.filter(x => x[0] === 'account.reference'))
      if (this.filters || this.preFilters) {
        const filtersAnd = this.filters.filter(x => x[0] !== 'account.reference')
        const filtersOr = this.filters.filter(x => x[0] === 'account.reference')
        params.filter_groups = [
          {
            filters: filtersAnd || this.preFilters
          }
        ]
        if (filtersOr.length > 0) {
          console.log(filtersOr[0])
          if (filtersOr.length > 1) {
            filtersOr[0][2] = [...filtersOr[0][2], ...filtersOr[1][2]]
            filtersOr.splice(1, 1)
          }
          params.filter_groups.push(
            {
              or: true,
              filters: filtersOr
            }
          )
        }
      }
      console.log(JSON.stringify(params))

      if (!this.$cookies.get('bypassCountry') || this.filter.country) {
        params.filter_groups.push(
          {
            filters: [
              ['country_iso_code', 'eq', this.filter.country || window.country]
            ]
          }
        )
      }

      let promise = this.$http.get(ctx.apiUrl, { params: params })

      return promise.then((data) => {
        const items = data.body.data
        // // Here we could override the busy state, setting isBusy to false
        // // this.isBusy = false
        this.totalRows = data.body.pagination.total
        return (items)
      }).catch(error => {
        console.log(error)
        // Here we could override the busy state, setting isBusy to false
        // this.isBusy = false
        // Returning an empty array, allows table to correctly handle busy state in case of error
        return []
      })
    },
    refreshTable (filters) {
      this.filters = filters
      setTimeout(() => {
        this.$root.$emit('bv::refresh::table', 'transactions-table')
        if (this.filter.createdDateRangeActive) {
          this.sortBy = 'created_at'
        }
        if (this.filter.imputedDateRangeActive) {
          this.sortBy = 'imputation_date'
        }
      }, 100)
    },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    onSearchCompanySelected(item) {
      this.filter.company.push({id: item.id, name: item.name, account_id: item.account ? item.account.id || null : null})
      this.$refs.companyAc.searchQuery = ''
    },
    // onAccountSearchCompanySelected(item) {
    //   this.accountOwner = item.name
    //   if (item.account) {
    //     this.accountingNote.account_id = item.account.id
    //     this.accountingNote.relationship = item.relationship
    //   } else {
    //     this.accountingNote.account_id = null
    //   }
    //   this.accountingNote.currency = window.countries.find(x => x.iso_code === item.country_iso_code).currency
    //   this.$refs.companyAccountAc.searchQuery = ''
    // },
    removeCompanyFromFilters(index) {
      this.filter.company.splice(index, 1)
    },
    onSearchUserSelected(item) {
      this.filter.user.push({id: item.id, email: item.email, account_id: item.account ? item.account.id || null : null})
      this.$refs.userAc.searchQuery = ''
    },
    // onAccountSearchUserSelected(item) {
    //   this.accountOwner = item.name
    //   if (item.account) {
    //     this.accountingNote.account_id = item.account.id
    //     this.accountingNote.relationship = item.company_id === null ? 'provider' : this.accountingNote.relationship
    //   } else {
    //     this.accountingNote.account_id = null
    //   }
    //   this.accountingNote.currency = window.countries.find(x => x.iso_code === item.country_iso_code).currency
    //   this.$refs.userAccountAc.searchQuery = ''
    // },
    removeUserFromFilters(index) {
      this.filter.user.splice(index, 1)
    },
    rowSelected(row) {
      console.log(row)
      if (row.length > 0) {
        this.panel.sum = row.map(item => item.type === 'credit' ? parseFloat(item.amount) : -parseFloat(item.amount)).reduce((prev, next) => prev + next)
        this.panel.currency = row[0].currency
        this.panel.credits = row.filter(item => item.type === 'credit').length
        this.panel.debits = row.filter(item => item.type === 'debit').length
        this.panel.shippings = [...new Set(row.map(item => item.shipping_id))]
      } else {
        this.panel.sum = null
      }
      this.invalidateTransactions = row
    },
    selectAll() {
      let transactionsTable = this.$refs.transactionsTable.$el
      let tableBody = transactionsTable.getElementsByTagName('tbody')[0]
      let tableRows = tableBody.getElementsByTagName('tr')
      this.unselectAll()
      for (const row of tableRows) {
        row.click()
      }
    },
    unselectAll() {
      this.$refs.transactionsTable.clearSelected()
    },
    downloadAccountingLogCsv() {
      let params = {
        format: 'upload',
        filter_groups: [
          {
            filters: []
          }
        ]
      }
      if (this.dbSource) {
        params = {...params, ...{dbSource: this.dbSource}}
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['country_iso_code', 'eq', window.country]
            ]
          }
        )
      }
      if (this.quickFilters['relationship'].length > 0) {
        params.filter_groups[0].filters.push([...this.quickFilters['relationship']])
      }
      if (this.quickFilters['country']) {
        params.filter_groups[0].filters.push([...this.quickFilters['country']])
      }
      if (this.quickFilters['company'].length > 0) {
        params.filter_groups[0].filters.push([...this.quickFilters['company'][0]])
      }
      if (this.quickFilters['user'].length > 0) {
        params.filter_groups[0].filters.push([...this.quickFilters['user'][0]])
      }
      if (this.quickFilters['imputationDateFrom'].length > 0) {
        params.filter_groups[0].filters.push(['imputation_date', 'bt', [this.quickFilters['imputationDateFrom'][2], this.quickFilters['imputationDateTo'][2]]])
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'accounts/transactions', {params: params})
        .then(response => {
          let obj = {
            title: this.$gettext('JOB DISPATCHED'),
            message: this.$gettext('The Report is being generated, you will receive an email with a link to download it as soon as it\'s done'),
            type: 'success'
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        })
    }
  }
}
</script>

<style lang="scss">
.company-card__profile-data {
  h5 {
    font-weight: 400;
    white-space: nowrap;
    margin-bottom: 0;
  }
}
</style>
